import PLIcon from "components/patternLib/PLIcon";
import PLPill from "components/patternLib/PLPill";
import React from "react";
import { TagListContainerSC, TagListItemSC } from "./styles";

import { SidebarTagProps } from "components/templates/TagsSidebar";

interface TagsListProps {
  handleDeleteTag?: (item: SidebarTagProps) => void;
  loading?: boolean;
  selectedTags?: SidebarTagProps[];
}

const TagsList: React.FC<TagsListProps> = ({ loading, selectedTags, handleDeleteTag }) => {
  return (
    <TagListContainerSC>
      {(selectedTags ?? [])?.map((item, index) => (
        <TagListItemSC key={`${item.id}-${item.label}-${index}`}>
          <PLPill label={item.label} noStates />
          <div
            className="deleteIcons"
            onClick={() => handleDeleteTag && handleDeleteTag(item)}
            style={{
              cursor: loading ? "initial" : "pointer",
            }}
          >
            <PLIcon iconName="bin" size="25px" />
          </div>
        </TagListItemSC>
      ))}
    </TagListContainerSC>
  );
};

export default TagsList;
